import React from 'react'
import {
  Typography,
  Box,
  Button,
  useTheme,
  CircularProgress,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import {
  deleteButtonStyles,
} from './style'
import { useState } from 'react'
import RenderMassData from './RenderMassData'

const MassDeleteDialog = ({ id, open, onClose, handleMassDelete, selectedMassData, context, customPosition }) => {
  const theme = useTheme()
  const [isDeleting, setIsDeleting] = useState(false)
  const [showAllAttachments, setShowAllAttachments] = useState(false)

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await handleMassDelete()
      await onClose()
      setIsDeleting(false)
    } catch (error) {
      setIsDeleting(false)

      console.log('Error deleting deal: ', error)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: 500,
          width: '90%',
          p: 2,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon sx={{ color: 'crimson' }} />
          <Typography sx={{ fontWeight: 'bold', color: 'crimson' }}>Confirm Deletion</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Are you sure you want to permanently delete the following item(s) from Grobotic?
        </Typography>

        <Stack spacing={1}>
          {selectedMassData.map(task => (
            <Box key={task?.SK}>
              <RenderMassData task={task} context={context} />
            </Box>
          ))}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between' }}>
        {isDeleting && <CircularProgress />}
        <Button
          sx={deleteButtonStyles(theme)}
          variant="outlined"
          // onClick={handleMassDelete}
          onClick={handleDelete}
          color="secondary"
          disabled={isDeleting}
        >
          Confirm
        </Button>
        <Button variant="contained" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MassDeleteDialog
